<!--
* @description 政策兑现与发布量
* @fileName policy.vue
* @author xuesong
* @date 2022/02/08 11:50:14
!-->
<template>
  <div id="Policy">
    <div class="wrapper">
      <div class="item" v-for="(item, index) in itemList" :key="index">
        <div class="item-left">
          <img
            src="@/assets/cockpit/policy.png"
            alt=""
            style="width: 44px; height: 44px"
          />
        </div>
        <div class="item-right">
          <div class="label">
            {{ item.label }}
          </div>
          <div class="count">
            {{ item.val ? item.val : '-' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Policy',
  data() {
    return {
      itemList: [
        {
          label: '已发布政策数',
          val: 1056
        },
        {
          label: '当前可申请兑现政策数',
          val: 1056
        },
        // {
        //   label: '正在申请兑现',
        //   val: null
        // },
        // {
        //   label: '正在申请兑现企业数',
        //   val: null
        // },
        {
          label: '已兑现金额(亿)',
          val: 6.07
        },
        {
          label: '已兑现企业数',
          val: 2229
        }
      ]
    }
  }
}
</script>
<style lang='scss' scoped>
#Policy {
  width: 100%;
  height: 100%;
  .wrapper {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    padding-left: 0.2rem;
    .item {
      width: 50%;
      height: 50%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      &-left {
        line-height: 0.44rem;
        margin-right: 0.05rem;
      }
      .label {
        line-height: 0.22rem;
        color: #fff;
        font-size: 0.12rem;
        margin-bottom: 0.05rem;
      }
      .count {
        line-height: 0.22rem;
        color: #fff;
        font-size: 0.24rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
